import type * as React from 'react';
import { SimilInputSpan } from '../../../../../../../ui/form/SimilInputSpan.tsx';
import { $SpaceCompact } from '../../../../../../../ui/form/SpaceCompact.ts';

export interface IButtonActionContainerProps {
  name?: React.ReactNode;
  children?: React.ReactNode;
}

export function ButtonActionContainer(props: IButtonActionContainerProps) {
  const { name, children: action } = props;

  return (
    <$SpaceCompact size="large" block>
      <SimilInputSpan style={{ minWidth: '200px', width: '100%' }}>
        {name}
      </SimilInputSpan>
      {action}
    </$SpaceCompact>
  );
}
